module.exports = __webpack_public_path__ + "img/VIA-alt.c70e75a2.svg";